import { memo } from 'react';

interface TableSortProps {
  sort: (sortVal: string, type: string, ascending: boolean) => void;
  column: string;
  sortVal: string;
  isAscending: boolean;
}

const DATE_COLUMNS = new Set([
  'Date',
  'Created',
  'Date Due',
  'Follow-Up-Date',
  'Last Activity',
  'Active Date',
  'Date Created',
  'Due Date',
  'Follow-Up Date',
  'Date Completed',
  'Inquiry Date',
  'Inactive Date'
]);

export const TableSort = memo(function TableSort({ sort, column, sortVal, isAscending }: TableSortProps): JSX.Element {
  const ascending = sortVal === column && isAscending === true;
  const descending = sortVal === column && isAscending === false;
  const sortType = DATE_COLUMNS.has(column) ? 'date' : 'alphabetical';

  return (
    <div className="table-sort-container">
      <div
        style={{ color: ascending ? 'black' : 'grey' }}
        className="hover"
        onClick={() => {
          sort(column, sortType, true);
        }}
      >
        ▲
      </div>
      <div
        style={{ color: descending ? 'black' : 'grey' }}
        className="hover"
        onClick={() => {
          sort(column, sortType, false);
        }}
      >
        ▼
      </div>
    </div>
  );
});
